// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p8-0";
export var leftAlign = "_p8-4";
export var listItem = "_p8-2";
export var listItemWrapper = "_p8-1";
export var operationText = "_p8-3";